
// Chakra imports
import { 
  Box, 
  Grid, 
  useToast, 
  Button, 
  Flex, 
  useColorModeValue,
  VStack,
  Card,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";

// Custom components
import Banner from "../../../views/admin/profile/components/Banner";

// Assets
import React, { useEffect, useState } from 'react';
import banner from "assets/img/auth/banner.png";
import avatar from "assets/img/avatars/avatar4.png";
import avatar2 from "assets/img/avatars/avatar9.png";
import { useParams, useSearchParams } from 'react-router-dom';
import { getData, putData } from "../../../utils/httpClient";
import PersonalData from "./components/PersonalData";
import ContactData from "./components/ContactData";
import AddressInfo from "./components/AddressInfo";
import EmergencyData from "./components/EmergencyData";
// Sección "Observaciones" eliminada por requerimiento del cliente.
// ObservationData queda en el repo por si se necesita volver a agregar.
import StudentData from "./components/StudentData";
import EscolaridadTab from "./components/EscolaridadTab";





export default function Overview() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'escolaridad' ? 1 : 0;
  const [studentData, setStudentData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const toast = useToast();
  const buttonColorScheme = useColorModeValue("brand", "brand");
  

  const getStudent = async () => {
    try {
      setInitialLoading(true);
      const response = await getData(
        `/person/findById/${id}`,
      );
      const studentInfo = response?.payload?.person || {};
      setStudentData(studentInfo);
      setEditedData(studentInfo);
    } catch (error) {
      toast({
        title: 'Error al obtener estudiante',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setInitialLoading(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedData(studentData);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      // Crear una copia de los datos y limpiar campos innecesarios
      const dataToSend = { ...editedData };
      
      // Limpiar campos que no deberían enviarse o que están vacíos
      Object.keys(dataToSend).forEach(key => {
        if (dataToSend[key] === '' || dataToSend[key] === null || dataToSend[key] === undefined) {
          delete dataToSend[key];
        }
      });

      // Limpiar objetos anidados
      if (dataToSend.address) {
        Object.keys(dataToSend.address).forEach(key => {
          if (dataToSend.address[key] === '' || dataToSend.address[key] === null || dataToSend.address[key] === undefined) {
            delete dataToSend.address[key];
          }
        });
        if (Object.keys(dataToSend.address).length === 0) {
          delete dataToSend.address;
        }
      }

      if (dataToSend.student) {
        Object.keys(dataToSend.student).forEach(key => {
          if (dataToSend.student[key] === '' || dataToSend.student[key] === null || dataToSend.student[key] === undefined) {
            delete dataToSend.student[key];
          }
        });
        if (Object.keys(dataToSend.student).length === 0) {
          delete dataToSend.student;
        }
      }
      
      // Temporalmente excluir la foto si es muy larga
      if (dataToSend.photo && dataToSend.photo.length > 100000) {
        console.log('Foto muy larga, excluyendo de la actualización');
        delete dataToSend.photo;
      }

      // Remover campos que no están en el DTO
      const allowedFields = [
        'name', 'secondName', 'lastName', 'maternalLastName', 'documentTypeId',
        'document', 'phone', 'cellPhone', 'birthPlace', 'birthDate', 'sexId',
        'email', 'address', 'profession', 'workPhone', 'workAddress',
        'emergencyContact', 'emergencyContactPhone', 'medicalInsurance',
        'mobileEmergency', 'photo', 'student', 'updatedBy',
      ];
      
      Object.keys(dataToSend).forEach(key => {
        if (!allowedFields.includes(key)) {
          delete dataToSend[key];
        }
      });
      
      console.log('Datos a enviar (limpiados):', dataToSend);
      const response = await putData(`/person/update/${id}`, dataToSend);
      
      if (response) {
        setStudentData(editedData);
        setIsEditing(false);
        toast({
          title: 'Perfil actualizado',
          description: 'Los datos del estudiante han sido actualizados exitosamente',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error al actualizar:', error);
      console.error('Error details:', error.response?.data);
      toast({
        title: 'Error al actualizar',
        description: error.response?.data?.message || 'Hubo un problema al actualizar los datos del estudiante',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFieldChange = (field, value) => {
    setEditedData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePhotoChange = (photoBase64) => {
    setEditedData(prev => ({
      ...prev,
      photo: photoBase64
    }));
  };
  
  useEffect(() => {
    getStudent();
  }, [id]);
  
  if (initialLoading) return null;

  // Mostrar mensaje si no hay datos del estudiante
  if (!studentData) {
    return (
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <Card maxW="4xl" mx="auto" p={8} borderRadius="lg" boxShadow="xl">
          <VStack spacing={4} align="center">
            <Text>No se encontraron datos del estudiante</Text>
            <Button colorScheme="blue" onClick={() => window.history.back()}>
              Volver
            </Button>
          </VStack>
        </Card>
      </Box>
    );
  }

  const personFullName = [
    studentData?.lastName,
    studentData?.maternalLastName,
    studentData?.name,
    studentData?.secondName,
  ]
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Tabs colorScheme="brand" variant="enclosed" isLazy defaultIndex={initialTab}>
        <TabList mb={4}>
          <Tab>Datos</Tab>
          <Tab>Escolaridad</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            {/* Botones de edición */}
            <Flex justify="flex-end" mb="20px">
              {!isEditing ? (
                <Button
                  colorScheme={buttonColorScheme}
                  onClick={handleEdit}
                  size="md"
                >
                  Editar Perfil
                </Button>
              ) : (
                <Flex gap="10px">
                  <Button
                    variant="outline"
                    onClick={handleCancel}
                    size="md"
                  >
                    Cancelar
                  </Button>
                  <Button
                    colorScheme={buttonColorScheme}
                    onClick={handleSave}
                    size="md"
                    isLoading={isLoading}
                  >
                    Guardar Cambios
                  </Button>
                </Flex>
              )}
            </Flex>

            <Grid
              templateColumns={{
                base: "1fr",
                lg: "1.34fr 2.62fr",
              }}
              templateRows={{
                base: "repeat(1fr)",
                lg: "1fr",
              }}
              gap={{ base: "20px", xl: "20px" }}>
              <Banner
                gridArea='1 / 1 / 2 / 2'
                banner={banner}
                avatar={isEditing && editedData?.photo ? editedData.photo : (studentData?.photo || (studentData?.sex?.id === 1 ? avatar2 : avatar))}
                name={`${studentData?.name} ${studentData?.lastName}`}
                job='Estudiante'
                posts='17'
                followers='9.7k'
                following='274'
                isEditing={isEditing}
                onPhotoChange={handlePhotoChange}
              />
              <PersonalData
                gridArea='1'
                studentData={isEditing ? editedData : studentData}
                isEditing={isEditing}
                onFieldChange={handleFieldChange}
              />
            </Grid>
            <Grid
              templateColumns={{
                base: "1fr",
                lg: "1fr 1fr",
              }}
              templateRows={{
                base: "repeat(3, 1fr)",
                lg: "1fr",
              }}
              gap={{ base: "20px", xl: "20px" }}
              mt={{ base: "20px", lg: "20px" }}>
              <ContactData
                gridArea='1'
                studentData={isEditing ? editedData : studentData}
                isEditing={isEditing}
                onFieldChange={handleFieldChange}
              />
              <AddressInfo
                gridArea='1'
                studentData={isEditing ? editedData : studentData}
                isEditing={isEditing}
                onFieldChange={handleFieldChange}
              />
              <EmergencyData
                gridArea='1'
                studentData={isEditing ? editedData : studentData}
                isEditing={isEditing}
                onFieldChange={handleFieldChange}
              />
            </Grid>
            <Grid
              templateColumns={{
                base: "1fr",
                lg: "1fr",
              }}
              templateRows={{
                base: "repeat(3, 1fr)",
                lg: "1fr",
              }}
              gap={{ base: "20px", xl: "20px" }}
              mt={{ base: "20px", lg: "20px" }}>
              <StudentData
                gridArea='1'
                studentData={isEditing ? editedData : studentData}
                isEditing={isEditing}
                onFieldChange={handleFieldChange}
              />
            </Grid>
          </TabPanel>

          <TabPanel px={0}>
            <EscolaridadTab
              studentId={studentData?.student?.id}
              personName={personFullName}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
